import dayjs from 'dayjs';
import { Form, Spin } from 'antd';
import utc from 'dayjs/plugin/utc';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useGetQueryV3Mutation } from 'store/features/api/graphSlice';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import LeaseV9NewTrailModeScheduleTable from '../create/LeaseV9NewTrailModeScheduleTable';

dayjs.extend(utc);

const LeaseV9NewTrailModeScheduleView = ({ screen, viewData, dataFullyLoaded = false }) => {
	const { state } = useLocation();
	const form = Form.useFormInstance();

	const [isClicked, setIsClicked] = useState(false);
	const [hasLoadedData, setHasLoadedData] = useState(false);
	const [flag, setFlag] = useState({
		check: 0,
		editable: 0,
	});

	const { creatorOrganizationId } = useSelector((state) => state.profile.profileData);

	const companyCode = creatorOrganizationId;

	const [getLeaseTableData, { data: leaseControlDataV3, isLoading: isLeaseTableDataLoading }] = useGetQueryV3Mutation();
	const [getLeaseData, { data: leaseControlData, isLoading: isLeaseControlDataLoading }] = useSendControlDataMutation();

	const queryV3Loader = async (force = false) => {
		// if (!hasLoadedData || force) {
		const version = String(viewData?.version);

		console.log(viewData, 'viewData');

		// if (viewData?.activationStatus?.toLowerCase() !== 'active') {
		// 	await handleDataLoading();
		// 	return;
		// }

		if (version && companyCode) {
			await getLeaseTableData({
				companyCode,
				name: 'leaseSchedulesOnVersion-TM-v9',
				fieldValues: [companyCode, state._id, version],
				fieldCodes: ['companyCode', 'identityRecordIdString', 'version'],
			});
		}

		setHasLoadedData(true);
		// }
	};

	const memoizedLeaseControlData = useMemo(() => {
		// if ((screen?.toLowerCase() === 'view' || flag?.check === 0) && viewData?.activationStatus?.toLowerCase() === 'active') {
		return leaseControlDataV3?.results ?? [];
		// }

		// return leaseControlData?.responseData ?? [];
	}, [flag?.check, leaseControlDataV3, leaseControlData, queryV3Loader]);

	const handleDataLoading = async () => {
		setIsClicked(true);

		let payloadData = {};
		const formData = form.getFieldsValue(true);

		if (dataFullyLoaded) {
			const effectiveChanges = form.getFieldValue('changes')?.filter((_, index) => index !== 0);

			const normalizedEffectiveChanges = effectiveChanges.map((item) => {
				const grossRentsLength = item?.inputChangeGrossRents?.length || 0;
				const advanceAmountsLength = item?.inputChangeAdvanceAmounts?.length || 0;

				if (grossRentsLength > advanceAmountsLength && Array.isArray(item?.inputChangeGrossRents)) {
					const paddedAdvanceAmounts = [...(item?.inputChangeAdvanceAmounts || [])];

					while (paddedAdvanceAmounts.length < grossRentsLength) {
						paddedAdvanceAmounts.push(0);
					}
					return {
						...item,
						inputChangeAdvanceAmounts: paddedAdvanceAmounts,
					};
				}
				return item;
			});

			payloadData = {
				advanceAmount: formData?.changes?.[0]?.inputChangeAdvanceAmounts?.reduce(
					(accumulator, currentValue) => accumulator + currentValue,
					0
				),
				leaseTerm: formData?.changes?.[0]?.inputChangeLeaseTerm,
				discountRate: formData?.changes?.[0]?.inputChangeDiscountRate,
				startDay: String(formData?.leaseStartDate?.date()),
				startMonth: String(formData?.leaseStartDate?.month() + 1),
				startYear: String(formData?.leaseStartDate?.year()),
				escalation: 0,
				paymentFrequency: formData?.changes?.[0]?.paymentFrequency,
				paymentTime: formData?.changes?.[0]?.paymentTime,
				advanceDuration: formData?.changes?.[0]?.inputChangeAdvanceAmounts?.filter((item) => item !== 0)?.length,
				upfrontLeasePayment: formData?.changes?.[0]?.upfrontLeasePayment,
				initialDirectCost: formData?.changes?.[0]?.initialDirectCost,
				securityDeposit: formData?.securityDeposit,
				endOfFinancialYear: formData?.endOfFinancialYear,
				advanceAmounts: formData?.changes?.[0]?.inputChangeAdvanceAmounts,
				grossRents: formData?.changes?.[0]?.inputChangeGrossRents,
				cashIncentiveAmount: formData?.cashIncentiveAmount ?? 0,
				changes: normalizedEffectiveChanges.map((item, index) => {
					if (index === normalizedEffectiveChanges.length - 1) {
						return {
							...item,
							inputChangeAdvance: formData?.advanceAmounts?.reduce((acc, curr) => acc + curr, 0),
							inputChangeAdvanceAmounts: formData?.advanceAmounts,
							inputChangeGrossRents: formData?.grossRents,
							upfrontLeasePayment: formData?.upfrontLeasePayment,
							initialDirectCost: formData?.initialDirectCost,
							securityDeposit: formData?.securityDeposit,
							cashIncentiveAmount: formData?.cashIncentiveAmount ?? 0,
							inputChangeDiscountRate: formData?.initialDiscountRate,
						};
					}
					return {
						...item,
					};
				}),
				grossRent: 0,
			};

			if (
				Array.isArray(payloadData.grossRents) &&
				Array.isArray(payloadData.advanceAmounts) &&
				payloadData.grossRents.length > payloadData.advanceAmounts.length
			) {
				const paddedAdvanceAmounts = [...payloadData.advanceAmounts];
				while (paddedAdvanceAmounts.length < payloadData.grossRents.length) {
					paddedAdvanceAmounts.push(0);
				}
				payloadData.advanceAmounts = paddedAdvanceAmounts;
			}
		}

		const convertJson = JSON.stringify(payloadData);

		const convertBase64 = btoa(convertJson);
		const formattedPayload = {
			data: convertBase64,
			processCode: state?.processCode,
			scriptName: 'lease-controller-lease',
			payloadData: payloadData,
		};

		try {
			await getLeaseData(formattedPayload).unwrap();
		} catch (error) {
			console.error('Error in data loading:', error);
		}
	};

	// useImperativeHandle(ref, () => ({
	// 	handleDataLoading,
	// 	flag,
	// 	setFlag,
	// 	queryV3Loader,
	// }));

	useEffect(() => {
		if (viewData?.version) {
			queryV3Loader();
		}
	}, [viewData]);

	return (
		// <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '4px', pt: '15px', flexDirection: 'column' }}>
		// 	<Spin spinning={isLeaseControlDataLoading}>
		// 		<Spin spinning={isLeaseTableDataLoading || isLeaseControlDataLoading}>
		// 			{memoizedLeaseControlData?.length > 0 && (
		// 				<CardAccordion
		// 					darkTitle={true}
		// 					title="Lease Schedule"
		// 					typographySX={{ fontSize: '16px !important' }}
		// 					customHeaderSX={{
		// 						p: '10px',
		// 						fontSize: '16px',
		// 						backgroundColor: '#e1f0ff !important',
		// 					}}
		// 				>
		// 					<LeaseTable
		// 						screen={screen}
		// 						isClicked={isClicked}
		// 						queryV3Loader={queryV3Loader}
		// 						leaseControlData={memoizedLeaseControlData}
		// 					/>
		// 				</CardAccordion>
		// 			)}
		// 		</Spin>
		// 	</Spin>
		// </Box>

		<Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '4px', flexDirection: 'column' }}>
			<Spin spinning={isLeaseControlDataLoading}>
				<Spin spinning={isLeaseTableDataLoading || isLeaseControlDataLoading}>
					{memoizedLeaseControlData?.length > 0 && (
						<>
							<LeaseV9NewTrailModeScheduleTable
								screen={'CREATE'}
								viewData={viewData}
								isClicked={isClicked}
								queryV3Loader={queryV3Loader}
								leaseControlData={memoizedLeaseControlData}
							/>
						</>
					)}
				</Spin>
			</Spin>
		</Box>
	);
};

LeaseV9NewTrailModeScheduleView.displayName = 'LeaseSchedule';

export default LeaseV9NewTrailModeScheduleView;
